import { render, staticRenderFns } from "./GaRiskBadge.vue?vue&type=template&id=5fa00b6e&"
import script from "./GaRiskBadge.vue?vue&type=script&lang=ts&"
export * from "./GaRiskBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports